export default {
    'upload-asset': 'Upload asset',
    'search-placeholder': 'Search by name',
    download: 'Download',
    'copy-public-url': 'Copy public URL',
    copied: 'Public URL has been copied to clipboard.',
    select: 'Select',
    list: {
        empty: {
            title: 'No assets found',
            message: 'Upload a file to get started.',
        },
        headers: {
            name: 'Name',
            mimeType: 'Type',
            createdAt: 'Uploaded at',
        },
    },
    picker: {
        title: 'Select organization asset',
        description: 'Choose an existing asset or upload a new file.',
    },
}
